var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKadenaExplorerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3279 0H14.2709L5.96594 8.715V15.975L21.3279 0Z",
    fill: "url(#paint0_linear_101_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.965 0H0V24H5.965V0Z",
    fill: "#27B7E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.868 24.0001L12.068 9.57605L8.07397 13.729L14.941 24.0031L21.868 24.0001Z",
    fill: "url(#paint1_linear_101_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_16",
    x1: 5.73551,
    y1: 7.9875,
    x2: 20.7442,
    y2: 7.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#054F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#054F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#1174B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#1A91CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#21A6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#25B2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#27B7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_16",
    x1: 7.10839,
    y1: 13.2838,
    x2: 15.4987,
    y2: 17.4897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#054F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#0B62AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1581C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#1D98D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#22A9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#25B3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#27B7E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKadenaExplorerLogo);
export default __webpack_public_path__ + "static/media/kadena-explorer-logo.a9e25c443688a4db3268e5886cc26040.svg";
export { ForwardRef as ReactComponent };